import React from 'react';

import Chip from '@mui/material/Chip';

import { TaskProcessTypeEnum } from '@/types/enums/task-process-type.enum';
import { t } from '@/utils/lang';

export interface StatusChipProps {
    status: TaskProcessTypeEnum | 'default';
    size?: 'small' | 'medium';
    showChip?: boolean;
}

const ChipTaskProcessTypeStatus: React.FC<StatusChipProps> = ({
    status,
    size = 'medium',
    showChip = true,
}) => {
    let label: string;
    let color: 'info' | 'primary' | 'error' | 'warning' | 'default';

    switch (status?.toLowerCase()) {
        case TaskProcessTypeEnum.NEW.toLowerCase():
        case 'new':
            label = 'Task yêu cầu';
            color = 'info';
            break;
        case TaskProcessTypeEnum.RECURRING.toLowerCase():
        case 'recurring':
            label = 'Task lặp lại';
            color = 'error';
            break;
        case TaskProcessTypeEnum.AD_HOC.toLowerCase():
        case 'ad_hoc':
            label = 'Task phát sinh';
            color = 'warning';
            break;
        default:
            label = t('Không xác định');
            color = 'default';
            break;
    }

    if (showChip) {
        return (
            <Chip
                variant='tonal'
                label={t(label, 'TaskProcessType')}
                color={color}
                size={size}
                sx={{ fontSize: 12 }}
            />
        );
    }

    return {
        label: t(label, 'TaskProcessType'),
        color,
    };
};

export default ChipTaskProcessTypeStatus;
